import clsx from "clsx";
import { BrandingLogo } from "@/components/branding/BrandingLogo";

type CampsiteBrandBarProps = {
  siteName: string;
  logoUrl?: string | null;
  className?: string;
  compact?: boolean;
};

/** Zentrierte Markenzeile für Gäste-Tablet und Infobildschirm. */
export function CampsiteBrandBar({
  siteName,
  logoUrl,
  className,
  compact = false,
}: CampsiteBrandBarProps) {
  return (
    <div
      className={clsx(
        "flex items-center justify-center gap-3",
        compact ? "py-2" : "py-3",
        className,
      )}
    >
      <BrandingLogo
        logoUrl={logoUrl}
        siteName={siteName}
        imgClassName={compact ? "max-h-10 max-w-[10rem]" : "max-h-12 max-w-[14rem]"}
        fallbackClassName={compact ? "text-xl" : "text-2xl"}
      />
      <span
        className={clsx(
          "font-semibold text-label",
          compact ? "text-base" : "text-lg",
        )}
      >
        {siteName}
      </span>
    </div>
  );
}
